import { AxiosInstance } from 'axios';

const auditServices = (instance: AxiosInstance) => {
  const list = (filter) =>
    instance.get(`/audit-op?include=operacion${filter}`).then((response: any) => {
      const { data, ...rest } = response.data.result;
      return [data, rest];
    });

  const printAudit = ({ id_formula, codigo, color }) =>
    instance.post('/audit-op/print', { data: { id_formula, codigo, color } });

  const create = ({ id_registro, operacion, data }) =>
    instance.post('/audit-op/create', { data: { id_registro, operacion, data } });

  return {
    list,
    create,
    printAudit,
  };
};
export default auditServices;
